export default "__VITE_ASSET__2161047a__"